import React from 'react';
import { useViewport } from 'components/templates/viewportProvider';
import { Banner } from 'components/atoms/banner';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
import Marker from 'assets/images/marker.png';
import Bed from 'assets/images/bed.png';
import Area from 'assets/images/Icon---28.png';
import Bath from 'assets/images/bathroom.png';
import Guest from 'assets/images/person.png';
//eslint-disable-next-line
import styles from "./styles.scss";

const RentalDetailBanner = props => {
  const { isMobile } = useViewport();
  const {
    banner_video,
    bath,
    bed,
    guest,
    image,
    location,
    mobile_image,
    project_name,
    reference_no,
    thumbnail,
    title,
    area,
    is_completed_project,
    completed_project_name,
  } = props.data;

  let className = isMobile
    ? 'rental-detail-banner mobile'
    : 'rental-detail-banner';
  let imageUrl = image;
  let name = is_completed_project ? completed_project_name : project_name;
  if (isMobile) {
    imageUrl = mobile_image;
  }

  const referenceNumber = () => {
    return (
      <div className={'reference-number'}>
        Reference number <br />
        {reference_no}
      </div>
    );
  };

  const rentalBannerCard = () => {
    return (
      <div className={'rentals-banner-card'}>
        <div className={'location-container card-item'}>
          <div className={'address-container'}>
            <img className={'location-img'} src={Marker} alt={''} />
            <div className={`address ${!isMobile ? 'top-padding' : ''}`}>
              <h4>{location}</h4>
              <h4>{name}</h4>
            </div>
          </div>
        </div>
        <div className={'mobile-styles'}>
          {guest && (
            <div className={'guest card-item'}>
              <div className={'top-padding'}>
                {!isMobile && <img src={Guest} alt={''} />}
                <div>
                  {isMobile ? (
                    <h4>{`${guest}${' '}guests`}</h4>
                  ) : (
                    <h3>{`${guest}${' '}guests`}</h3>
                  )}
                </div>
              </div>
            </div>
          )}
          {!isMobile && bed && (
            <div className={'bedrooms card-item'}>
              <div className={'top-padding'}>
                {!isMobile && <img src={Bed} alt={''} />}
                <div>
                  {isMobile ? (
                    <h4>{`${bed}${' '}bedrooms`}</h4>
                  ) : (
                    <h3>{`${bed}${' '}bedrooms`}</h3>
                  )}
                </div>
              </div>
            </div>
          )}
          {bath && (
            <div className={'bathrooms card-item'}>
              <div className={'top-padding'}>
                {!isMobile && <img src={Bath} alt={''} />}
                <div>
                  {isMobile ? (
                    <h4>{`${bath}${' '}bathrooms`}</h4>
                  ) : (
                    <h3>{`${bath}${' '}bathrooms`}</h3>
                  )}
                </div>
              </div>
            </div>
          )}
          {isMobile && bed && (
            <div className={'bedrooms card-item'}>
              <div className={'top-padding'}>
                {!isMobile && <img src={Bed} alt={''} />}
                <div>
                  {isMobile ? (
                    <h4>{`${bed}${' '}bedrooms`}</h4>
                  ) : (
                    <h3>{`${bed}${' '}bedrooms`}</h3>
                  )}
                </div>
              </div>
            </div>
          )}
          {area && (
            <div className={'product-area card-item'}>
              <div className={'top-padding'}>
                {!isMobile && <img src={Area} alt={''} />}
                <div>
                  {isMobile ? (
                    <h4>{`${area}${' '}sqft`}</h4>
                  ) : (
                    <h3>{`${area}${' '}sqft`}</h3>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className={className} id={'banner'}>
      <Banner
        imageUrl={imageUrl}
        thumbNailUrl={thumbnail}
        title={title}
        titleHeading={referenceNumber()}
        containerClassName={'rental-detail-banner-image'}
      />
      {location && rentalBannerCard()}
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
    </div>
  );
};

export default RentalDetailBanner;
